module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _vm._m(0)
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "chapter"
  }, [_c('div', {
    staticClass: "inner_page"
  }, [_c('p', {
    staticClass: "dedic1"
  }, [_c('i', [_vm._v("For Rachael, whose unconditional love and unwavering support are never-ending")])]), _vm._v(" "), _c('p', {
    staticClass: "dedic"
  }, [_vm._v("—David")]), _vm._v(" "), _c('p', {
    staticClass: "dedic1"
  }, [_c('i', [_vm._v("For Henry Waylon Sinibaldi and Melrose Anne Stoval, the two latest members of my favorite team ")])]), _vm._v(" "), _c('p', {
    staticClass: "dedic"
  }, [_vm._v("—Raymond")]), _vm._v(" "), _c('p', {
    staticClass: "dedic1"
  }, [_c('i', [_vm._v("To Pam, whose endless patience allowed me to devote all the time necessary to a project such as this ")])]), _vm._v(" "), _c('p', {
    staticClass: "dedic"
  }, [_vm._v("—Kerry")])])])
}]}


//////////////////
// WEBPACK FOOTER
// ../node_modules/vue-loader/lib/template-compiler?{"id":"data-v-0c5ae74a","hasScoped":false,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"}}!../node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/Dedication.vue
// module id = 72
// module chunks = 0